<template>
  <div></div>
</template>

<script>

const updateFunction = (self) => {
  self.$api.deviceInfo.get();
};

const removeTimer = (interval) => {
  try {
    clearInterval(interval);
  } catch {}
};

export default {
  name: 'DeviceStatus',
  data() {
    return {
      interval: null,
    };
  },
  mounted() {
    const self = this;

    if (this.interval) {
      removeTimer(this.interval);
    }

    // TODO: Only update Device Status on Login / Logout
    updateFunction(self);
    this.interval = setInterval(() => {
      updateFunction(self);
    }, 60000);
  },
  beforeDestroy() {
    removeTimer(this.interval);
  },
};
</script>

<style scoped>

</style>
